import apiService from "./api";

// Ručno knjiženje propuštenih narudžbi (samo admin; backend odgovor 30.10.2026, ticket #223889).
// Narudžba se ne može proknjižiti dvaput: dupli klik je bezbjedan. Odgovor po narudžbi: status posted (transaction_id) |
// skipped (message = razlog) | no_op | failed (message).
const ledgerAdminService = {
  // Neproknjižene narudžbe svih restorana. ?from=&to=&limit=; meta: total, returned, truncated, value_sum.
  getMissing(params) {
    return apiService.get(`/admin/ledger/missing`, params);
  },
  // Stanje jedne narudžbe: posted, can_post, reason, transactions.
  getOrder(orderId) {
    return apiService.get(`/admin/ledger/orders/${orderId}`);
  },
  postOrder(orderId) {
    return apiService.post(`/admin/ledger/orders/${orderId}/post`, {});
  },
  // order_ids: najviše 200
  postOrders(orderIds) {
    return apiService.post(`/admin/ledger/orders/post`, { order_ids: orderIds });
  },
};

export const MAX_BULK_POST = 200;

export default ledgerAdminService;
